// Domain configuration for multi-domain deployment
export const DOMAIN_CONFIG = {
  // Static site domain (marketing pages)
  STATIC_DOMAIN: process.env.REACT_APP_STATIC_DOMAIN || 'https://nkenne.ai',
  
  // Portal domain (auth, dashboard, payment)
  PORTAL_DOMAIN: process.env.REACT_APP_PORTAL_DOMAIN || 'https://developers.nkenne.ai',
  
  // Check if we're on the static site or portal site
  IS_STATIC_SITE: process.env.REACT_APP_SITE_TYPE === 'static',
  IS_PORTAL_SITE: process.env.REACT_APP_SITE_TYPE === 'portal',
};

// Helper functions for cross-domain navigation
export const getPortalUrl = (path = '') => {
  const portalDomain = DOMAIN_CONFIG.PORTAL_DOMAIN.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${portalDomain}${cleanPath}`;
};

export const getStaticUrl = (path = '') => {
  const staticDomain = DOMAIN_CONFIG.STATIC_DOMAIN.replace(/\/$/, '');
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${staticDomain}${cleanPath}`;
};
